export default "__VITE_ASSET__501Q9e32__ 640w, __VITE_ASSET__BmPGW4cy__ 1024w, __VITE_ASSET__fQ7WU6dD__ 1920w";